import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getPermissions } from "../store/rootReducer";

const LANDING_BY_PERMISSION = [
  ["actionItems", "/dashboard/queue"],
  ["accounts", "/dashboard/receipts"],
  ["orders", "/dashboard/orders"],
  ["users", "/dashboard/user"],
];

export const useRoleLanding = () => {
  const permissions = useSelector(getPermissions) || {};


  if (permissions.dashboard) return null;

  const match = LANDING_BY_PERMISSION.find(([key]) => permissions[key]);
  return match ? match[1] : null;
};

const RoleLanding = () => {
  const landing = useRoleLanding();
  return landing ? <Navigate to={landing} replace /> : null;
};

export default RoleLanding;
